import React from 'react'
import styled from 'styled-components'
import { giphyDarkGrey, giphyDarkestGrey, giphyLightCharcoal, giphyLightestGrey, giphyLightGrey } from '@giphy/js-brand'
import { EmojiVariationsList } from '@giphy/react-components'
import { getGifHeight } from '@giphy/js-util'
import type { NonPaginatedGifsResult } from '@giphy/js-fetch-api'
import type { Side } from '@floating-ui/react-dom-interactions'

import { GifPopover, GifPopoverProps } from './gif-popover'

export type EmojiPopoverProps = GifPopoverProps & {
    fetchVariations: (id: string | number) => Promise<NonPaginatedGifsResult>
    EmojiVariationsListProps?: Partial<React.ComponentPropsWithoutRef<typeof EmojiVariationsList>>
}

const StyledEmojiVariationsList = styled(EmojiVariationsList)<{ $side: Side }>`
    background: ${({ $side }) =>
        $side === 'top'
            ? `linear-gradient(-180deg, ${giphyDarkGrey} 0%, ${giphyDarkestGrey} 100%)`
            : `linear-gradient(-180deg, ${giphyDarkestGrey} 0%, ${giphyDarkGrey} 100%)`};
    position: relative;

    & .${EmojiVariationsList.variationsViewportClassName} {
        scrollbar-width: thin;

        &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            -webkit-appearance: none;
        }

        &::-webkit-scrollbar-track {
            border-radius: 10px;
            background: ${giphyLightCharcoal};
            margin: 0 8px;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: ${giphyLightGrey};
        }

        &::-webkit-scrollbar-thumb:hover {
            background-color: ${giphyLightestGrey};
        }

        &::-webkit-scrollbar-thumb:active {
            background-color: ${giphyLightestGrey};
        }
    }
`

export function EmojiPopover(props: EmojiPopoverProps) {
    const { fetchVariations, gifWidth, EmojiVariationsListProps, context, ...other } = props
    const gifHeight = context.gif ? getGifHeight(context.gif, gifWidth) : gifWidth

    return (
        <GifPopover gifWidth={gifWidth} context={context} {...other}>
            {context.gif ? (
                <StyledEmojiVariationsList
                    $side={context.side}
                    fetchVariations={fetchVariations}
                    gif={context.gif}
                    gifHeight={gifHeight}
                    gifWidth={gifWidth}
                    gutter={5}
                    hideAttribution={true}
                    noLink={true}
                    {...EmojiVariationsListProps}
                />
            ) : null}
        </GifPopover>
    )
}
